var compAnotacoes = Vue.component('anotacoes', {

    template: '#anotacoes-comp',
    parent: compQuestao,
    ready: function(){
        this.questaoId = this.$parent.id;
        var self = this;
        ajaxGET(
            '/questao/anotacoes/carregar',
            {questaoId: this.questaoId},
            function (dados) {
                self.anotacoes = dados;
                self.$parent.carregando.anotacoes = false;

                Vue.nextTick(function(){
                    inicializaTooltips();
                });
            }
        );
    },
    data: function () {
        return {
            dadosCarregados     : false,
            questaoId           : -1,
            editandoAnotacao    : -1,
            anotacoes           : {}
        }
    },
    methods: {
        excluirAnotacao: function( anotacaoId ){
            confirma(
                {
                    titulo  : 'Deseja mesmo excluir esta anotação?',
                    conteudo: 'Não será possível recuperá-la futuramente.'
                },
                this.excluiAnotacao,
                {anotacaoId: anotacaoId}
            )
        },
        excluiAnotacao: function( dados ){

            ajaxPOST(
                '/questao/anotacoes/excluir',
                dados,
                this.removeAnotacaoVue
            );
        },
        removeAnotacaoVue: function ( anotacaoExcluidaId ) {
            Vue.delete(this.anotacoes, anotacaoExcluidaId);
        },
        editarAnotacao: function ( anotacaoId ) {
            this.editandoAnotacao = anotacaoId;

            Vue.nextTick(function(){
                // jQuery focus() não funciona! Esse nativo sim
                $('#anotacao-' + anotacaoId).get(0).focus();
            });
        },
        salvaEdicaoAnotacao: function ( anotacaoId ) {
            var novoTexto = $('#anotacao-' + anotacaoId).text();
            this.anotacoes[anotacaoId].texto = novoTexto;
            this.editandoAnotacao = -1;

            ajaxPOST(
                '/questao/anotacoes/atualizar',
                { anotacaoId: anotacaoId, novoTexto: novoTexto }
            );
        },
        cancelaEdicaoAnotacao: function ( anotacaoId ) {
            var self = this;
            this.editandoAnotacao = -1;
            $('#anotacao-' + anotacaoId).text( self.anotacoes[anotacaoId].texto );
        },
        limparNovaAnotacao: function ( verificar ) {

            var self = this;
            var novaNota = $('#anotacao-nova-' + self.questaoId);
            var conteudo = novaNota.text();

            // caso não seja a primeira edição, apenas retorna
            if( verificar && (conteudo.indexOf('Escreva aqui uma nova nota e clique em [criar nota].') == -1) ){
                return;
            }

            // limpa tdo o conteúdo da nota
            novaNota.html('<br>');
            return novaNota.get(0).focus();
        },
        criarAnotacao: function ( ) {
            var self = this;
            var novaNota = $('#anotacao-nova-' + self.questaoId);
            var texto = novaNota.text();
            var instucao = 'Escreva aqui uma nova nota e clique em [criar nota].';

            // Nota vazia: limpa e retorna
            if( texto.trim() == '' || texto.trim() == instucao.trim() ){
                novaNota.html('<br>');
                return novaNota.get(0).focus();
            }

            ajaxPOST(
                '/questao/anotacoes/criar',
                { texto: texto, questaoId: this.questaoId },
                this.novaAnotacaoCriada
            );
        },
        novaAnotacaoCriada: function ( novaAnotacao ) {

            Vue.set(this.anotacoes, novaAnotacao.id, novaAnotacao);

            var instrucoes = 'Escreva aqui uma nova nota e clique em [criar nota].';
            var self = this;
            $('#anotacao-nova-' + self.questaoId).text(instrucoes);
        }
    }
});